import { Box } from '@mui/system';

import { DataSetDeliveryTable } from './components/DataSetDeliveryTable';
import { DatasetDeliveryTableHeader } from './components/DatasetDeliveryTableHeader';
import { DatasetModalProvider } from './context/DatasetManifestDialogContext';

const DatasetDelivery: React.FC = () => {
  return (
    <DatasetModalProvider>
      <Box data-testid="dataset-delivery-page">
        <DatasetDeliveryTableHeader />
        <DataSetDeliveryTable />
      </Box>
    </DatasetModalProvider>
  );
};

export default DatasetDelivery;
